module.exports = __webpack_public_path__ + "img/pic_logo.1c429403.png";